import { render } from "./MainComponent.vue?vue&type=template&id=058dd2ba&scoped=true"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"

import "./MainComponent.vue?vue&type=style&index=0&id=058dd2ba&lang=scss&scoped=true"

import exportComponent from "C:\\www\\farming_chat_pc_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058dd2ba"]])

export default __exports__